module.exports = __webpack_public_path__ + "static/screenshot3-58a84cf5ef01074cc7963eea78b24d91.png";